import React from 'react'

import formatTime from '../utilities/format-time'

import moment from 'moment'

const Byline = ({ story }) => {
  const DATE_FORMAT = 'MMM DD, YYYY, h:mma'
  const publicAt = story?.originalPublishedAt ? moment(story.originalPublishedAt).format(DATE_FORMAT) : ''
  const updatedAt = formatTime(story?.publishedAt)

  const addJoinPart = (index, length) => {
    const step = length - 1 - index

    if (step > 1) {
      return ', '
    }

    if (step === 1) {
      return ' and '
    }

    return ' '
  }

  return (
    <div className='byline'>
      <div className='date-byline'>
        <span className='public-at'>{publicAt}</span>
        <span className='text'>{`Updated${updatedAt.includes(',') ? ' on' : ''} ${updatedAt}`}</span>
      </div>
      {story?.authors?.length ? (
        <div>
          <span>By: </span>
          {story?.authors?.map((author, index) => (
            <>
              {author?.fields?.byline !== 'News 12 Staff' ? (
                <a href={`author/${author?.fields?.slug}`} className='author'>
                  {author?.fields?.byline}
                </a>
              ) : (
                <span key={`${author}-${index}`} className='author'>
                  {author?.fields?.byline}
                </span>
              )}
              {addJoinPart(index, story?.authors?.length)}
            </>
          ))}
        </div>
      ) : null}
    </div>
  )
}

export default Byline
